import React, { useState, useEffect } from 'react';
import styles from './style/EditModal.module.css';
import DOMPurify from 'dompurify'; // 💡 DOMPurify 라이브러리 추가
import { useTranslation } from "react-i18next"; // 👈 추가

export default function EditIntroductionModal({ currentIntroduction, onClose, onSave }) {
  const { t } = useTranslation(); // 👈 추가
  const [newIntroduction, setNewIntroduction] = useState(currentIntroduction);
  const [error, setError] = useState('');
  
  // Define max length
  const MAX_LENGTH = 1000;

  useEffect(() => {
    setNewIntroduction(currentIntroduction);
  }, [currentIntroduction]);

  const handleSubmit = (e) => {
    e.preventDefault();

    // 💡 입력값 정제 및 유효성 검사
    const sanitizedIntroduction = DOMPurify.sanitize(newIntroduction.trim());
    
    if (sanitizedIntroduction.length > MAX_LENGTH) {
      // 💡 i18n 키로 대체 및 변수 사용
      setError(t('mypage.modal.intro.error.maxLength', { maxLength: MAX_LENGTH })); 
      return;
    }
    
    // 💡 정제된 값을 상위 컴포넌트로 전달
    setError('');
    onSave(sanitizedIntroduction);
  };

  return (
    <div className={styles.modalOverlay}>
      <div className={styles.modalContent}>
        {/* 💡 i18n 키로 대체 */}
        <h3>{t('mypage.modal.intro.title')}</h3>
        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            {/* <label htmlFor="introduction">새 자기소개:</label> */}
            <textarea
              id="introduction"
              value={newIntroduction}
              onChange={(e) => setNewIntroduction(e.target.value)}
              className={styles.textareaField}
              rows={8}
              maxLength={MAX_LENGTH}
              // 💡 i18n 키로 대체
              placeholder={t('mypage.modal.intro.placeholder')} 
            />
            <div className={styles.charCounter}>
              {newIntroduction ? newIntroduction.length : 0} / {MAX_LENGTH}
            </div>
            {error && <p className={styles.errorMessage}>{error}</p>}
          </div>
          <div className={styles.buttonGroup}>
            {/* 💡 i18n 키로 대체 */}
            <button type="submit" className={styles.saveBtn}>{t('mypage.modal.button.save')}</button>
            <button type="button" onClick={onClose} className={styles.cancelBtn}>{t('mypage.modal.button.cancel')}</button>
          </div>
        </form>
      </div>
    </div>
  );
}